import React from "react";
import PdfViewer from "../../PdfViewer";

const IncidenciasRH = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Incidencias-RH.pdf`;
  /*const pdfUrl = "/pdf/Incidencias-RH.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Incidencias RH</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default IncidenciasRH;
